<template>
    <div class="table-component">
        <q-table ref="tableRef" :rows="rows ?? dataTable.rows" :columns="columnsTable" :no-data-label="messageNotData"
            v-model:pagination="dataTable.pagination" :rows-per-page-label="messageRowsPerPage" @request="emitOnRequest"
            :loading="loading" :rows-per-page-options="optionsPagination" :visible-columns="visibles"
            :class="getTableStyle()" :selection="selection" v-model:selected.sync="items"
            @update:selected="emitSelectedItems" :row-key="multipleSelectionKey" :virtual-scroll="enableVirtualScroll"
            :title="titleTable" dense @row-click="($event, row) => onClickCell(row, $event.target)">
            <template v-if="enableVisibleColumns" v-slot:top-right>
                <q-select v-model="visibles" multiple filled dense options-dense :display-value="$q.lang.table.columns"
                    emit-value map-options :options="columnsTable" option-value="name" options-cover
                    style="min-width: 150px" />
            </template>

            <template v-slot:body-cell-actions="props">
                <q-td :props="props">
                    <div>
                        <q-btn class="table-component-edit-btn" v-if="isEditEnable" dense round flat icon="edit"
                            @click="emitEditBtn(props.row)">
                            <q-tooltip>Editar registro</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-config-btn" v-if="isConfigEnable" dense round flat icon="settings"
                            @click="isConfigBtn(props.row)">
                            <q-tooltip>{{ configTooltip }}</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-config-btn" v-if="isDetailEnable" dense round flat icon="info"
                            @click="emitDetailBtn(props.row)">
                            <q-tooltip>Ver Detalles</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-ballot-btn" v-if="isBallotEnable" dense round flat icon="ballot"
                            @click="emitBallotBtn(props.row)">
                            <q-tooltip>Ver Papeleta</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-route-btn" v-if="isRouteEnable" dense round flat icon="route"
                            @click="emitRouteBtn(props.row)">
                            <q-tooltip>Ver Ruta</q-tooltip>
                        </q-btn>
                        <q-btn v-if="isMapEnable" dense round flat color="primary" icon="map"
                            @click="emitMapBtn(props.row)">
                            <q-tooltip>Ver Mapa</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-company-btn" v-if="isCompanyEnable" dense round flat
                            icon="apartment" @click="emitCompanyBtn(props.row)">
                            <q-tooltip>Asignar empresas</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-quota-btn" v-if="isQuotaEnable" dense round flat icon="paid"
                            @click="emitQuotaBtn(props.row)">
                            <q-tooltip>Gestionar cupos</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-plan-btn" v-if="isPlanEnable" dense round flat icon="payments"
                            @click="emitPlanBtn(props.row)">
                            <q-tooltip>Gestionar planes</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-tracking-btn" v-if="isTrackingEnable" dense round flat
                            icon="my_location" @click="emitTrackingBtn(props.row)">
                            <q-tooltip>Ver Rastreo</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-checkpoint" v-if="isCheckpointEnable" dense round flat
                            icon="location_on" @click="emitCheckpointBtn(props.row)">
                            <q-tooltip>Ver Puntos de Control</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-sector" v-if="isSectorEnable" dense round flat
                            icon="drag_indicator" @click="emitSectorBtn(props.row)">
                            <q-tooltip>Ver Sectores</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-stop" v-if="isStopEnable" dense round flat icon="share_location"
                            @click="emitStopBtn(props.row)">
                            <q-tooltip>Ver Paradas</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-status" v-if="isStatusEnable" dense round flat icon="fact_check"
                            @click="emitStatusBtn(props.row)">
                            <q-tooltip>Gestionar estados de proyecto</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-stop" v-if="isIdentifierEnable" dense round flat icon="sell"
                            @click="emitIdentifierBtn(props.row)">
                            <q-tooltip>Gestionar etiquetas de proyecto</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-incidence-time" v-if="isIncidenceTimeEnable" dense round flat
                            icon="timer" @click="emitIncidenceTimeBtn(props.row)">
                            <q-tooltip>Gestionar tiempos de incidencia</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-send" v-if="isSendEnable" dense round flat icon="send"
                            @click="emitSend(props.row)">
                            <q-tooltip>Enviar datos</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-passenger-payment-method" v-if="isPassengerPaymentMethodEnable"
                            dense round flat icon="add_card" @click="emitPassengerPaymentMethod(props.row)">
                            <q-tooltip>Asignar Medio de Pago a Pasajero</q-tooltip>
                        </q-btn>
                        <q-btn v-if="isLabelPassengerEnable" dense round flat color="primary" icon="group_add"
                            @click="emitLabelPassenger(props.row)">
                            <q-tooltip>Asignar Clientes</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-deposit-btn" v-if="isDepositEnable" dense round flat
                            icon="note_add" @click="emitDepositBtn(props.row)">
                            <q-tooltip>Agregar Comprobante</q-tooltip>
                        </q-btn>
                        <q-btn v-if="isUrlEnable" dense round flat icon="link" @click="emitUrlBtn(props.row)">
                            <q-tooltip>Visitar enlace externo</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-deposit-image-btn" v-if="isDepositImageEnable" dense round flat
                            icon="image" @click="emitDepositImageBtn(props.row)">
                            <q-tooltip>Ver Comprobante</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-deposit-reverse-btn" v-if="isDepositReverseEnable" dense round
                            flat icon="assignment_return" @click="emitDepositReverseBtn(props.row)">
                            <q-tooltip>Realizar Reverso del Comprobante</q-tooltip>
                        </q-btn>
                        <q-btn
                            v-if="(isDeleteEnable && props.row.is_active) || (isRestoreEnable && !props.row.is_active)"
                            :class="props.row.is_active ? 'table-component-erase-btn' : 'table-component-restore'" dense
                            round flat :icon="props.row.is_active ? 'do_not_disturb_on' : 'check_circle'"
                            @click="emitIsActive(props.row)">
                            <q-tooltip v-if="props.row.is_active == 1">
                                Desactivar registro
                            </q-tooltip>
                            <q-tooltip v-else>
                                Activar registro
                            </q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-delete-btn" v-if="isEraseEnable" dense round flat
                            icon="delete_forever" @click="emitEraseBtn(props.row)">
                            <q-tooltip>Borrar registro</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-password-btn" v-if="isSendEmailEnable" dense round flat
                            icon="password" @click="emitSendEmail(props.row)">
                            <q-tooltip>Enviar contraseña temporal a correo electrónico</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-remove-route-btn" v-if="isRemoveRouteEnable" dense round flat
                            icon="remove_road" @click="emitRemoveRoute(props.row)">
                            <q-tooltip>Limpiar trazado de la ruta</q-tooltip>
                        </q-btn>
                        <q-btn class="table-component-historic-btn" v-if="isHistoricEnable" dense round flat
                            icon="manage_history" @click="emitHistoricBtn(props.row)">
                            <q-tooltip>{{ historicTooltip }}</q-tooltip>
                        </q-btn>
                        <q-btn v-if="isReloadEnable" dense round flat color="primary" icon="refresh"
                            @click="emitReload(props.row)">
                            <q-tooltip>Recargar la página</q-tooltip>
                        </q-btn>
                        <q-btn v-if="isCloseSessionEnable" dense round flat color="negative" icon="person_remove"
                            @click="emitCloseSession(props.row)">
                            <q-tooltip>Cerrar sesión</q-tooltip>
                        </q-btn>
                    </div>
                </q-td>
            </template>

            <template v-slot:body-cell-long-name="props">
                <q-td :props="props" class="table-component-description">
                    {{ props.row.name }}
                </q-td>
            </template>

            <template v-slot:body-cell-incidence_label="props">
                <q-td :props="props" class="table-component-incidence">
                    {{ props.row.incidence_label }}
                </q-td>
            </template>

            <template v-slot:body-cell-color="props">
                <q-td :props="props" @click="emitColorBtn(props.row)">
                    <span class="material-symbols-outlined" :style="`color: ${props.row.color}; font-size: 1.4rem`">
                        radio_button_checked
                    </span>
                    <q-tooltip>Cambiar color de admistrador</q-tooltip>
                </q-td>
            </template>


            <template v-slot:body-cell-cost_center_label="props">
                <q-td :props="props">
                    <div v-if="props.row.incidence.incidence_identifiers.length > 0">
                        <div v-for="(row, index) in props.row.incidence.incidence_identifiers" :key="index">
                            {{ row.identifier ? row.identifier.name : '' }}
                        </div>
                    </div>

                    <span v-if="props.row.incidence.incidence_identifiers.length == 0">
                        {{ props.row.cost_center_label }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-description="props">
                <q-td :props="props" class="table-component-description">
                    {{ props.row.description }}
                </q-td>
            </template>

            <template v-slot:body-cell-description_show="props">
                <q-td :props="props" class="table-component-description">
                    {{ props.row.description }}
                </q-td>
            </template>


            <template v-slot:body-cell-reason="props">
                <q-td :props="props" class="table-component-description">
                    {{ props.row.reason }}
                </q-td>
            </template>

            <template v-slot:body-cell-active="props">
                <q-td :props="props">
                    <span :class="props.row.is_active ? 'table-component-active' : 'table-component-inactive'">
                        {{ props.row.active }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-status="props">
                <q-td :props="props">
                    <span :class="props.row.is_status ? 'table-component-active' : 'table-component-inactive'">
                        {{ props.row.status }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-status-recharger="props">
                <q-td :props="props">
                    <span
                        :class="props.row.status == RechargerTransactionStatus.READY ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.status_label }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-status-monitoring="props">
                <q-td :props="props">
                    <span class="material-symbols-outlined" :style="getMonitoringStatusStyle(props.row)?.style">
                        radio_button_checked
                    </span>
                    <q-tooltip>
                        {{ getMonitoringStatusStyle(props.row)?.tooltip }}
                    </q-tooltip>
                </q-td>
            </template>

            <template v-slot:body-cell-has-connection-medium="props">
                <q-td :props="props">
                    <span
                        :class="props.row.has_connection_medium == 'Si' ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.has_connection_medium }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-has_payment_methods="props">
                <q-td :props="props">
                    <span
                        :class="props.row.has_payment_methods == 'Si' ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.has_payment_methods }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-amount_payment_methods="props">
                <q-td :props="props">
                    <span
                        :class="props.row.amount_payment_methods > 0 ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.amount_payment_methods }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-balance_returned="props">
                <q-td :props="props">
                    <span
                        :class="props.row.balance_returned == 'Si' ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.balance_returned }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-is-reverse="props">
                <q-td :props="props">
                    <span
                        :class="props.row.is_reverse_label == 'Si' ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.is_reverse_label }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-is-config-valid="props">
                <q-td :props="props">
                    <span
                        :class="props.row.is_config_label == 'Completa' ? 'table-component-true-state' : 'table-component-false-state'">
                        {{ props.row.is_config_label }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-list-checkboxs="props">
                <q-td>
                    <q-list dense padding class="rounded-borders">
                        <q-item padding v-for="(item, index) in props.row.items" :key="index" v-ripple>
                            <q-checkbox v-model="item.is_active" checked-icon="task_alt" unchecked-icon="highlight_off"
                                color="positive" :label="item.name" :dense="denseCheckboxs" :disable="item.is_disable"
                                @update:model-value="(value) => emitItemCheckbox(value, props.row, item)" />
                        </q-item>
                    </q-list>
                </q-td>
            </template>

            <template v-slot:body-cell-list-hierarchies="props">
                <q-td>
                    <q-list dense padding class="rounded-borders">
                        <q-item padding v-for="(item, index) in props.row.items" :key="index" v-ripple>
                            <q-select filled v-model="item.hierarchy"
                                @update:model-value="(value) => emitHierarchy(value, props.row)"
                                :options="getOptionsHierarchy(item.rank_hierarchy.min, item.rank_hierarchy.max)"
                                :dense="true" :disable="!item.is_active" />
                        </q-item>
                    </q-list>
                </q-td>
            </template>

            <template v-slot:body-cell-hierarchies="props">
                <q-td>
                    <q-list :dense="true" padding class="rounded-borders">
                        <q-item padding v-for="(item, index) in props.row.items" :key="index" v-ripple>
                            <q-input filled v-model="item.hierarchy" :dense="true" :disable="true"
                                style="max-width: 55px;" />
                        </q-item>
                    </q-list>
                </q-td>
            </template>

            <template v-slot:body-cell-hierarchies-form="props">
                <td>
                    <q-item tag="label" v-ripple class="table-body__col-item">
                        <q-item-section>
                            <q-select filled v-model="props.row.hierarchy"
                                @update:model-value="(value) => emitHierarchy(value, props.row)"
                                :options="getOptionsHierarchy(props.row.rank_hierarchy.min, props.row.rank_hierarchy.max)"
                                :dense="true" />
                        </q-item-section>
                    </q-item>
                </td>
            </template>

            <template v-slot:body-cell-json="props">
                <q-td style="padding: 0;" colspan="100%">
                    <div class="row table-component-td-json">
                        <div class="col-9 ellipsis">
                            {{ truncateJson(props.row?.details) }}
                        </div>
                        <div class="col-3 text-right">
                            <q-btn flat dense :icon="iconExpanded" @click="toggleJsonExpansion(props.row)" />
                        </div>
                    </div>

                    <div v-if="expandedRow == props.row" class="text-left">
                        <pre class="table-component-language-json">
                            <code>
                                {{ props.row.details }}
                            </code>
                        </pre>
                    </div>
                </q-td>
            </template>

            <template v-if="enableDragAndDrop" v-slot:body="props">
                <q-tr draggable="true" @dragstart="dragStart($event, props.row)" @dragover.prevent
                    @drop="dragDrop($event, props.row)" @click="emitRow(props.row)">
                    <q-td v-for="(col, index) in props.cols" :key="index" :style="`text-align: ${col.align}`">
                        {{ props.row[col.field] }}

                        <span v-if="col.name == 'active'"
                            :style="(props.row.is_active ? 'color:#21BA45' : 'color:#C10015')">
                            {{ props.row.active }}
                        </span>

                        <div v-if="col.name == 'actions'">
                            <q-btn class="table-component-edit-btn" v-if="isEditEnable" dense round flat icon="edit"
                                @click="emitEditBtn(props.row)">
                                <q-tooltip>Editar registro</q-tooltip>
                            </q-btn>
                            <q-btn
                                v-if="(isDeleteEnable && props.row.is_active) || (isRestoreEnable && !props.row.is_active)"
                                :class="props.row.is_active ? 'table-component-erase-btn' : 'table-component-restore'"
                                dense round flat :icon="props.row.is_active ? 'do_not_disturb_on' : 'check_circle'"
                                @click="emitIsActive(props.row)">
                                <q-tooltip v-if="props.row.is_active == 1">
                                    Desactivar registro
                                </q-tooltip>
                                <q-tooltip v-else>
                                    Activar registro
                                </q-tooltip>
                            </q-btn>
                            <q-btn class="table-component-delete-btn" v-if="isEraseEnable" dense round flat
                                icon="delete_forever" @click="emitEraseBtn(props.row)">
                                <q-tooltip>Borrar registro</q-tooltip>
                            </q-btn>
                            <q-btn v-if="isConfigEnable" dense round flat color="grey-7" icon="settings"
                                @click="isConfigBtn(props.row)">
                                <q-tooltip>{{ configTooltip }}</q-tooltip>
                            </q-btn>
                        </div>
                    </q-td>
                </q-tr>
            </template>

            <template v-if="isFooterEnable" v-slot:bottom-row>
                <q-tr class="bg-grey-3">
                    <q-td :colspan="colspanFooter" class="text-left">
                        <span class="table-component-key-footer">{{ keyFooter }}</span>
                        <span>{{ valueFooter }}</span>
                    </q-td>
                </q-tr>
            </template>

            <template v-slot:body-cell-status-incidence="props">
                <q-td :props="props">
                    <span :style="getStatusIncidenceStyle(props.row.current_status)">
                        {{ props.row.status_label }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-priority-incidence="props">
                <q-td :props="props">
                    <span :class="getPriorityIncidenceStyle(props.row.priority)">
                        {{ props.row.priority_label }}
                    </span>
                </q-td>
            </template>

            <template v-slot:body-cell-origin-incidence="props">
                <q-td :props="props">
                    <span :class="getOriginIncidenceStyle(props.row.origin)">
                        {{ props.row.origin_label }}
                    </span>
                </q-td>
            </template>
        </q-table>
    </div>
</template>

<script lang="ts">
import TableComponent from './TableComponent';
export default TableComponent;
</script>

<style lang="scss" src="./TableComponent.scss"></style>